import axios from "axios";
export default {
    state:{
        allitems:[],
    },
    mutations:{
        setAllItems(state,items){
            state.allitems=items
        }
    },
    actions:{
        async setAllCompras({commit,rootState,getters}){
           await axios.get(`${rootState.urlapi}/facturas/compras`,getters.getTokenUser).then(res=>{
                commit("setAllItems",res.data)
              }).catch(err=>{console.error(err)});
        }
    },
    getters:{
        getAllCompras(state){
            return state.allitems
        },
    }
}